// clearance-report.js

import html2canvas from 'html2canvas';

// Map of “fancy” Unicode → ASCII fallbacks for CSV friendliness
const charMap = new Map([
   ['\u2714', 'OK'], // ✅
   ['\u2716', 'X'], // ✖
   ['\u2718', 'X'], // ✘
   ['\u2713', 'OK'], // ✓
   ['\u2013', '-'], // – en dash
   ['\u2014', '-'], // — em dash
   ['\u2192', ' to '], // → right arrow
   ['\u2190', ' to '], // ← left arrow
   ['\u00B0', ' deg'], // ° degree
   ['\u00D7', 'x'], // × multiply
   ['\u00F7', '/'], // ÷ divide
   ['\u00A0', ' '], // nbsp
   ['\u2264', '<='], // ≤
   ['\u2265', '>='], // ≥
   ['\u00B1', '+/-'], // ±
]);

// Initialise report modal
export function initReport() {
   $(function () {
      $('#view-report-summary-btn').on('click', showReportDialog);

      // Hook up footer buttons
      $('#btn-screenshot').on('click', saveAsImage);
      $('#btn-export-csv').on('click', exportCSV);
      $('#btn-better-print').on('click', printReport);
   });
}

function showReportDialog() {
   // Set report date
   const today = new Date();
   $('#report-date-text').text(today.toLocaleDateString());

   // --- Collect data ---
   // These should come from your existing summary panel and sweepBlocksTable
   const summaryHtml = $('#results-summary-panel').html() || '<p>No summary available.</p>';
   const $rows = $('#sweepBlocksTable tbody tr').clone();

   // --- Populate modal ---
   $('#report-summary-section').html(summaryHtml);
   $('#report-summary-table tbody').empty().append($rows);

   // Show modal
   const modalEl = document.getElementById('reportSummaryModalClearance');
   if (modalEl) {
      const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
      modal.show();
   }
}

// Save modal content as PNG image
function saveAsImage() {
   const content = document.getElementById('report-summary-content');
   if (!content) return;

   html2canvas(content).then((canvas) => {
      const link = document.createElement('a');
      link.download = `clearance-report-${Date.now()}.png`;
      link.href = canvas.toDataURL();
      link.click();
   });
}

// Export table as CSV
// --- CSV export with UTF-8 BOM + Unicode→ASCII normalisation ---
// Uses comma as delimiter; change CSV_DELIM to ';' if your Excel locale expects semicolons.
function exportCSV() {
   try {
      // Choose delimiter for your locale (Excel AU typically fine with comma)
      const CSV_DELIM = ',';

      // Normalise text pulled from the table so Excel won’t misinterpret characters
      const normalizeTextForCSV = (str) => {
         if (str == null) return '';
         let s = String(str);

         // Replace mapped characters
         for (const [from, to] of charMap.entries()) {
            s = s.split(from).join(to);
         }

         // Collapse any remaining weird whitespace/newlines/tabs to single spaces
         s = s
            .replace(/[\r\n\t]+/g, ' ')
            .replace(/\s{2,}/g, ' ')
            .trim();

         return s;
      };

      // Build rows: include the THEAD, then TBODY
      const rows = [];

      // Header row(s)
      $('#report-summary-table thead tr').each(function () {
         const cols = [];
         $(this)
            .find('th,td')
            .each(function () {
               const text = normalizeTextForCSV($(this).text());
               cols.push(text);
            });
         rows.push(cols.join(CSV_DELIM));
      });

      // Body rows
      $('#report-summary-table tbody tr').each(function () {
         const cols = [];
         $(this)
            .find('th,td')
            .each(function () {
               const text = normalizeTextForCSV($(this).text());
               cols.push(text);
            });
         rows.push(cols.join(CSV_DELIM));
      });

      const csvData = rows.join('\n');

      // Prepend UTF-8 BOM so Excel recognises encoding
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });

      // Trigger download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // Optional: include date in filename
      const stamp = new Date().toISOString().slice(0, 10);
      link.download = `clearance-report-${stamp}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
   } catch (err) {
      console.error('CSV export failed:', err);
   }
}

function printReport() {
   // Grab only the report body content (not the whole page)
   const modalHTML = document.querySelector('#report-summary-content').outerHTML;

   // Open a new popup window for printing
   const printWindow = window.open('', '', 'width=1024,height=768');

   // Build current date/time string in AU format
   const now = new Date();
   const dateStr = now.toLocaleDateString('en-AU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
   });

   // Write the print document
   printWindow.document.write(`
    <html>
    <head>
      <title>Trailer Clearance Report</title>
      <link rel="stylesheet" href="/bootstrap-5.2.3-dist/css/bootstrap.min.css">
      <style>
        body { padding: 2rem; font-family: sans-serif; }
        h1 { font-size: 1.5rem; }
        table { font-size: 0.85rem; }
      </style>
    </head>
    <body>
      <h1 class="text-center mb-4">Trailer Clearance Report</h1>
      <p class="text-center text-muted">Generated on: ${dateStr}</p>
      ${modalHTML}
      <script>
        window.onload = () => window.print();
      </script>
    </body>
    </html>
  `);

   // Close the stream so the browser can render
   printWindow.document.close();
}
